module.exports = __webpack_public_path__ + "Kanit-Regular.dee71812c8870b4c5ec6.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/app/src/assets/fonts/Kanit-Regular.ttf
// module id = ../../../../../src/assets/fonts/Kanit-Regular.ttf
// module chunks = styles